import { Component, OnInit, OnDestroy, EventEmitter, Output } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { getTotalDiscountsByContact, getPartnerInfo } from "@edp-store/selectors/contract.selectors";
import { Subject } from "rxjs";
import { takeUntil, filter } from "rxjs/operators";
import { ITotalDiscountsByContract } from "@edp-models/total-discount-contract.model";
import { Partner } from "@edp-models/edp-partner.model";
import { GetTotalDiscountsByContract } from "@edp-store/actions/contract.actions";

@Component({
    selector: "edp-overlay-benefits",
    templateUrl: "./edp-overlay-benefits.component.html",
    styleUrls: ["./edp-overlay-benefits.component.scss"],
})
export class EdpOverlayBenefitsComponent implements OnInit, OnDestroy {
    @Output() public closeSideBar = new EventEmitter<boolean>();
    public discounts: ITotalDiscountsByContract;
    public hasPack: boolean;
    public partnerships: Partner[];
    private unsubscribe = new Subject();
    public loading = true;

    constructor(private store: Store<IAppState>) {
        this.store.select(getTotalDiscountsByContact).pipe(
            filter(results => !!results)
        ).subscribe(totalDiscounts => {
            this.discounts = totalDiscounts;
            this.loading = false;
         });

        this.store.pipe(
            takeUntil(this.unsubscribe),
            select(getPartnerInfo),
            filter(val => val !== null && val !== undefined)
        ).subscribe((partnerInfo) => {
            this.partnerships = partnerInfo.partnerships;
        });
    }

    ngOnInit() {
        this.store.dispatch(new GetTotalDiscountsByContract());
    }

    public close() {
        this.closeSideBar.emit();
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
